@if (markOnly()) {
  @if (isDark()) {
    <!-- mark · dark (luminous drop for ocean surfaces) -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
      [attr.height]="height()"
      [attr.width]="width()"
      role="img"
      [attr.aria-label]="label()">
      <defs>
        <linearGradient [attr.id]="uid + 'b'" x1=".5" y1="0" x2=".5" y2="1">
          <stop offset="0%" stop-color="#9BE5F7" />
          <stop offset="35%" stop-color="#5DC8E8" />
          <stop offset="70%" stop-color="#34A6D6" />
          <stop offset="100%" stop-color="#1C7AAE" />
        </linearGradient>
        <radialGradient [attr.id]="uid + 'g'" cx=".35" cy=".3" r=".42">
          <stop offset="0%" stop-color="#fff" stop-opacity=".85" />
          <stop offset="100%" stop-color="#CAEDFB" stop-opacity="0" />
        </radialGradient>
      </defs>
      <path
        d="M40 4 C28 20 18 34 18 48 C18 62 28 72 40 72 C52 72 62 62 62 48 C62 34 52 20 40 4 Z"
        [attr.fill]="'url(#' + uid + 'b)'"
        stroke="rgba(180,236,251,.45)"
        stroke-width="1.1" />
      <path
        d="M40 4 C28 20 18 34 18 48 C18 62 28 72 40 72 C52 72 62 62 62 48 C62 34 52 20 40 4 Z"
        [attr.fill]="'url(#' + uid + 'g)'" />
      <path
        d="M20 50 L29 50 L33 50 L36 43 L40 56 L44 44 L47 51 L49 50 L62 50"
        fill="none"
        stroke="#fff"
        stroke-width="2.5"
        stroke-linejoin="round"
        stroke-linecap="round"
        opacity=".98" />
    </svg>
  } @else {
    <!-- mark · light -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 80"
      [attr.height]="height()"
      [attr.width]="width()"
      role="img"
      [attr.aria-label]="label()">
      <defs>
        <linearGradient [attr.id]="uid + 'b'" x1=".5" y1="0" x2=".5" y2="1">
          <stop offset="0%" stop-color="#5DC8E8" />
          <stop offset="35%" stop-color="#2D98C9" />
          <stop offset="70%" stop-color="#0F5E8A" />
          <stop offset="100%" stop-color="#082F4A" />
        </linearGradient>
        <radialGradient [attr.id]="uid + 'g'" cx=".35" cy=".3" r=".4">
          <stop offset="0%" stop-color="#fff" stop-opacity=".75" />
          <stop offset="100%" stop-color="#CAEDFB" stop-opacity="0" />
        </radialGradient>
      </defs>
      <path
        d="M40 4 C28 20 18 34 18 48 C18 62 28 72 40 72 C52 72 62 62 62 48 C62 34 52 20 40 4 Z"
        [attr.fill]="'url(#' + uid + 'b)'" />
      <path
        d="M40 4 C28 20 18 34 18 48 C18 62 28 72 40 72 C52 72 62 62 62 48 C62 34 52 20 40 4 Z"
        [attr.fill]="'url(#' + uid + 'g)'" />
      <path
        d="M20 50 L29 50 L33 50 L36 43 L40 56 L44 44 L47 51 L49 50 L62 50"
        fill="none"
        stroke="#fff"
        stroke-width="2.5"
        stroke-linejoin="round"
        stroke-linecap="round"
        opacity=".95" />
    </svg>
  }
} @else {
  @if (isDark()) {
    <!-- full lockup · dark -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 100"
      [attr.height]="height()"
      [attr.width]="width()"
      role="img"
      [attr.aria-label]="label()">
      <defs>
        <linearGradient [attr.id]="uid + 'b'" x1=".5" y1="0" x2=".5" y2="1">
          <stop offset="0%" stop-color="#9BE5F7" />
          <stop offset="35%" stop-color="#5DC8E8" />
          <stop offset="70%" stop-color="#34A6D6" />
          <stop offset="100%" stop-color="#1C7AAE" />
        </linearGradient>
        <radialGradient [attr.id]="uid + 'g'" cx=".35" cy=".3" r=".42" fx=".32" fy=".25">
          <stop offset="0%" stop-color="#fff" stop-opacity=".85" />
          <stop offset="100%" stop-color="#CAEDFB" stop-opacity="0" />
        </radialGradient>
      </defs>
      <g transform="translate(6,4)">
        <path
          d="M44 4 C30 22 20 38 20 52 C20 66 30 76 44 76 C58 76 68 66 68 52 C68 38 58 22 44 4 Z"
          [attr.fill]="'url(#' + uid + 'b)'"
          stroke="rgba(180,236,251,.45)"
          stroke-width="1" />
        <path
          d="M44 4 C30 22 20 38 20 52 C20 66 30 76 44 76 C58 76 68 66 68 52 C68 38 58 22 44 4 Z"
          [attr.fill]="'url(#' + uid + 'g)'" />
        <path
          d="M24 54 L34 54 L38 54 L41 46 L45 62 L49 48 L52 56 L54 54 L68 54"
          fill="none"
          stroke="#fff"
          stroke-width="2.2"
          stroke-linejoin="round"
          stroke-linecap="round"
          opacity=".98" />
      </g>
      <g
        transform="translate(96,58)"
        fill="#ffffff"
        font-family="Fraunces,'Times New Roman',serif"
        font-weight="500"
        font-size="36"
        font-style="italic"
        letter-spacing="-.015em">
        <text>
          Applied
          <tspan font-style="normal" font-weight="700">Bio</tspan>
          <tspan font-style="italic" fill="#F5A623">X</tspan>
        </text>
      </g>
      <text
        x="96"
        y="78"
        fill="rgba(255,255,255,.45)"
        font-family="'Geist Mono',monospace"
        font-size="9.5"
        letter-spacing="3">
        HYDROSTATIC · MOBILE
      </text>
    </svg>
  } @else {
    <!-- full lockup · light — refined white/light-surface lockup (AppliedBioX Logo.dc.html);
         tagline kept at #4F6C82 (WCAG --color-muted) rather than the design's stale #5B7A8E. -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 100"
      [attr.height]="height()"
      [attr.width]="width()"
      role="img"
      [attr.aria-label]="label()">
      <defs>
        <linearGradient [attr.id]="uid + 'b'" x1=".5" y1="0" x2=".5" y2="1">
          <stop offset="0%" stop-color="#5DC8E8" />
          <stop offset="35%" stop-color="#2D98C9" />
          <stop offset="70%" stop-color="#0F5E8A" />
          <stop offset="100%" stop-color="#082F4A" />
        </linearGradient>
        <radialGradient [attr.id]="uid + 'g'" cx=".35" cy=".3" r=".4" fx=".32" fy=".25">
          <stop offset="0%" stop-color="#fff" stop-opacity=".75" />
          <stop offset="50%" stop-color="#CAEDFB" stop-opacity=".25" />
          <stop offset="100%" stop-color="#CAEDFB" stop-opacity="0" />
        </radialGradient>
        <radialGradient [attr.id]="uid + 'i'" cx=".5" cy=".95" r=".45">
          <stop offset="0%" stop-color="#031D2E" stop-opacity=".5" />
          <stop offset="100%" stop-color="#031D2E" stop-opacity="0" />
        </radialGradient>
        <linearGradient [attr.id]="uid + 'r'" x1=".2" y1="0" x2=".8" y2="1">
          <stop offset="0%" stop-color="#fff" stop-opacity=".5" />
          <stop offset="50%" stop-color="#fff" stop-opacity=".08" />
          <stop offset="100%" stop-color="#fff" stop-opacity="0" />
        </linearGradient>
        <filter [attr.id]="uid + 's'" x="-12%" y="-8%" width="125%" height="125%">
          <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#0A3D5C" flood-opacity=".2" />
        </filter>
      </defs>
      <g transform="translate(6,4)" [attr.filter]="'url(#' + uid + 's)'">
        <path
          d="M44 4 C30 22 20 38 20 52 C20 66 30 76 44 76 C58 76 68 66 68 52 C68 38 58 22 44 4 Z"
          [attr.fill]="'url(#' + uid + 'b)'" />
      </g>
      <g transform="translate(6,4)">
        <path
          d="M44 4 C30 22 20 38 20 52 C20 66 30 76 44 76 C58 76 68 66 68 52 C68 38 58 22 44 4 Z"
          [attr.fill]="'url(#' + uid + 'i)'" />
        <path
          d="M44 4 C30 22 20 38 20 52 C20 66 30 76 44 76 C58 76 68 66 68 52 C68 38 58 22 44 4 Z"
          [attr.fill]="'url(#' + uid + 'g)'" />
        <path
          d="M44 6 C34 18 27 30 25 42"
          [attr.stroke]="'url(#' + uid + 'r)'"
          stroke-width="1.8"
          stroke-linecap="round"
          fill="none" />
        <ellipse cx="35" cy="26" rx="5" ry="3" fill="#fff" opacity=".3" transform="rotate(-20 35 26)" />
        <path
          d="M24 54 L34 54 L38 54 L41 46 L45 62 L49 48 L52 56 L54 54 L68 54"
          fill="none"
          stroke="#fff"
          stroke-width="2.2"
          stroke-linejoin="round"
          stroke-linecap="round"
          opacity=".95" />
      </g>
      <g
        transform="translate(96,58)"
        fill="#0A3D5C"
        font-family="Fraunces,'Times New Roman',serif"
        font-weight="500"
        font-size="36"
        font-style="italic"
        letter-spacing="-.015em">
        <text>
          Applied
          <tspan font-style="normal" font-weight="700">Bio</tspan>
          <tspan font-style="italic" fill="#D4860A">X</tspan>
        </text>
      </g>
      <text x="96" y="78" fill="#4F6C82" font-family="'Geist Mono',monospace" font-size="9.5" letter-spacing="3">
        HYDROSTATIC · MOBILE
      </text>
    </svg>
  }
}
